module.exports = __webpack_public_path__ + "img/9788925588735.d5559d0e.jpg";